import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { I18nProvider } from "@/lib/i18n";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import AuthCallback from "@/pages/AuthCallback";
import Pricing from "@/pages/Pricing";
import Partner from "@/pages/Partner";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Admin from "@/pages/Admin";
import AdminLogin from "@/pages/AdminLogin";
import Contact from "@/pages/Contact";
import PublicCv from "@/pages/PublicCv";
import ReferenceApprove from "@/pages/ReferenceApprove";
import VideoLetterPublic from "@/pages/VideoLetterPublic";
import PublicPortfolio from "@/pages/PublicPortfolio";
import PromoBanner from "@/pages/PromoBanner";
import ProtectedRoute from "@/components/ProtectedRoute";
import { ConfirmProvider } from "@/components/ConfirmDialog";
import { BrandingProvider } from "@/lib/branding";
import { Toaster } from "@/components/ui/sonner";

function AppRouter() {
  const location = useLocation();
  // CRITICAL: detect session_id during render to prevent race conditions
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/partner" element={<Partner />} />
      <Route path="/payment-success" element={<PaymentSuccess />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/cv/:slug" element={<PublicCv />} />
      <Route path="/refs/:token" element={<ReferenceApprove />} />
      <Route path="/video/:token" element={<VideoLetterPublic />} />
      <Route path="/p/:userId/:slug" element={<PublicPortfolio />} />
      <Route path="/promo" element={<PromoBanner />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <I18nProvider>
        <BrandingProvider>
          <ConfirmProvider>
            <BrowserRouter>
              <AppRouter />
              <Toaster position="bottom-right" />
            </BrowserRouter>
          </ConfirmProvider>
        </BrandingProvider>
      </I18nProvider>
    </AuthProvider>
  );
}

export default App;
